<mtg-news-detail
  [news]="news"
  [backUrl]="getVideoListRoute()"
></mtg-news-detail>
